module.exports = __webpack_public_path__ + "img/artwork-swiper-arrow.d6a2d391.svg";